import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import Time from "react-time-format";

class FormMandubPrint extends React.Component {
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const { RMM_data, MM_jorfilter } = value;

            const wakil = RMM_data.filter((el) => {
              if (MM_jorfilter == "$") {
                return el.joripara == "دۆلار";
              } else if (MM_jorfilter == "ID") {
                return el.joripara == "دینار";
              } else if (MM_jorfilter == "R") {
                return el.joripara == "ڕیمێمبی";
              } else {
                return el;
              }
            }).map((user, i) => {
              return (
                <tr key={i} className="fk f4">
                  <td className="fk" style={{ border: "2px solid #000" }}>
                    {user.note}
                  </td>
                  <td
                    className="fk"
                    style={{ border: "2px solid #000" }}
                    className={`${
                      user.joripara == "دۆلار" ? "text-black" : "text-black"
                    }`}
                  >
                    {user.joripara}
                  </td>
                  <td className="fk" style={{ border: "2px solid #000" }}>
                    <NumberFormat
                      value={
                        user.joripara == "دۆلار"
                          ? user.paraywargirawdolar
                          : user.paraywargirawdinar
                      }
                      thousandSeparator={true}
                      displayType="text"
                    />
                  </td>
                  <td
                    className="fk text-black"
                    style={{ border: "2px solid #000" }}
                  >
                    {user.Krini_RRR}
                  </td>
                  <td
                    className="fk text-black"
                    style={{ border: "2px solid #000" }}
                  >
                    {user.nrxe_RRR}
                  </td>
                  <td
                    className="fk text-black"
                    style={{ border: "2px solid #000" }}
                  >
                    {user.zhmaraaywasl}
                  </td>
                  <td className="fk" style={{ border: "2px solid #000" }}>
                    {user.nawishwen}
                  </td>
                  <td className="fk" style={{ border: "2px solid #000" }}>
                    {user.shwencode}
                  </td>
                  <td className="fk" style={{ border: "2px solid #000" }}>
                    <Time
                      value={user.date}
                      format="YYYY-MM-DD"
                      style={{ color: "black" }}
                    />
                  </td>
                  <td
                    className="fk"
                    style={{ border: "2px solid #000", cursor: "pointer" }}
                  >
                    {user.zhmara}
                  </td>
                </tr>
              );
            });

            return (
              <table id="example" className="table table-striped  text-right ">
                <thead>
                  <tr className="text-black f4">
                    <th style={{ border: "2px solid #000" }}>تێبینی</th>
                    <th style={{ border: "2px solid #000" }}>دراو</th>
                    <th style={{ border: "2px solid #000" }}>کۆی پسوولە</th>
                    <th style={{ border: "2px solid #000" }}>RRR کڕین</th>
                    <th style={{ border: "2px solid #000" }}>RRR نرخ</th>
                    <th style={{ border: "2px solid #000" }}>و.کۆمپانیا</th>
                    <th style={{ border: "2px solid #000" }}>ناوی بەڕێز</th>
                    <th style={{ border: "2px solid #000" }}>کۆد</th>
                    <th style={{ border: "2px solid #000" }}>بەروار</th>
                    <th style={{ border: "2px solid #000" }}>ژمارە</th>
                  </tr>
                </thead>
                <tbody>{wakil}</tbody>
              </table>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}
export default FormMandubPrint;
